import { NgModule } from '@angular/core';

import { ApRadioGroupComponent } from './radio-group.component';
import { ApRadioButtonComponent } from './button/radio-button.component';

/**
 * @name ApRadioModule
 * @ngdoc module
 */
@NgModule({
    imports: [ApRadioButtonComponent, ApRadioGroupComponent],
    exports: [ApRadioGroupComponent, ApRadioButtonComponent]
})
export class ApRadioModule {}
